<template>
    <div class="form-field-select w-full">
        <label :for="uid" v-if="label" class="text-md block font-semibold leading-6 text-gray-900">{{label}}</label>
        <select
            :id="uid"
            :required="required"
            :value="value"
            @input="(event) => { $emit('update', {field, value: event.target.value, event}) }"
            class="w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-sky-600 sm:text-sm sm:leading-6"
            :class="{
                'px-4 py-2.5 pr-8': !condensed,
                'px-2.5 py-1 pr-8' : condensed
            }"
        >
            <option v-if="blankOption"></option>
            <option v-for="item in items" :key="item[itemValue]" :value="item[itemValue]" :selected="value === item[itemValue]">{{ item[itemText] }}</option>
        </select>
    </div>
</template>

<script setup>
const uid = useId();
defineEmits([
    'update'
]);
</script>

<script>
export default {
    name: 'FormFieldSelect',
    props: {
        required: {
            required: false,
            type: Boolean,
            default: false,
        },
        label: {
            required: false,
            type: String,
        },
        id: {
            required: false,
            type: String,
            default: null,
        },
        field: {
            required: true,
            type: String,
        },
        value: {
            required: false,
        },
        items: {
            required: true,
            type: Array,
        },
        itemText: {
            required: true,
            type: String
        },
        itemValue: {
            required: true,
            type: String
        },
        condensed: {
            type: Boolean,
            default: false,
        },
        blankOption: {
            type: Boolean,
            default: true,
        },
    },
};
</script>
